import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Building {
  id: string;
  label: string;
  x: number;
  y: number;
  w: number;
  h: number;
  color: string;
  glow: string;
  bg: string;
  icon: string;
}
const buildings: Building[] = [{
  id: 'casino',
  label: 'Las Vegas Casino',
  x: 52,
  y: 22,
  w: 18,
  h: 14,
  color: '#a855f7',
  glow: '0 0 25px rgba(168,85,247,0.3)',
  bg: 'rgba(168,85,247,0.08)',
  icon: '♠'
}, {
  id: 'restaurant',
  label: 'Auszeit Restaurant',
  x: 38,
  y: 40,
  w: 16,
  h: 12,
  color: '#f59e0b',
  glow: '0 0 25px rgba(245,158,11,0.3)',
  bg: 'rgba(245,158,11,0.08)',
  icon: '◆'
}, {
  id: 'hotel',
  label: 'Hotel',
  x: 58,
  y: 42,
  w: 20,
  h: 16,
  color: '#0ea5e9',
  glow: '0 0 25px rgba(14,165,233,0.3)',
  bg: 'rgba(14,165,233,0.08)',
  icon: '■'
}, {
  id: 'shell',
  label: 'Shell Tankstelle',
  x: 18,
  y: 20,
  w: 22,
  h: 14,
  color: '#ef4444',
  glow: '0 0 25px rgba(239,68,68,0.3)',
  bg: 'rgba(239,68,68,0.08)',
  icon: '▲'
}, {
  id: 'lkw',
  label: 'LKW Parken',
  x: 12,
  y: 55,
  w: 30,
  h: 20,
  color: '#14b8a6',
  glow: '0 0 25px rgba(20,184,166,0.3)',
  bg: 'rgba(20,184,166,0.08)',
  icon: '▬'
}, {
  id: 'ionity',
  label: 'IONITY Ladestation',
  x: 46,
  y: 62,
  w: 16,
  h: 12,
  color: '#22c55e',
  glow: '0 0 25px rgba(34,197,94,0.3)',
  bg: 'rgba(34,197,94,0.08)',
  icon: '⚡'
}];
export function SiteMap() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  return <div className="w-full aspect-video lg:aspect-[4/3] rounded-3xl overflow-hidden relative bg-gray-100 border border-gray-200" data-id="element-288">
      {/* Grid pattern background */}
      <div className="absolute inset-0 opacity-[0.06] bg-[linear-gradient(rgba(0,0,0,0.08)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.08)_1px,transparent_1px)] bg-[size:20px_20px]" data-id="element-289" />

      {/* SVG layer for roads and paths */}
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-290">
        <defs data-id="element-291">
          <linearGradient id="roadGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-292">
            <stop offset="0%" stopColor="#d1d5db" data-id="element-293" />
            <stop offset="100%" stopColor="#e5e7eb" data-id="element-294" />
          </linearGradient>
        </defs>

        {/* A9 Autobahn — thick diagonal */}
        <line x1="88" y1="-2" x2="88" y2="102" stroke="#e5e7eb" strokeWidth="8" data-id="element-295" />
        <line x1="88" y1="-2" x2="88" y2="102" stroke="#d1d5db" strokeWidth="6" data-id="element-296" />
        {/* Center dashes */}
        <line x1="88" y1="-2" x2="88" y2="102" stroke="#f59e0b" strokeWidth="0.4" strokeDasharray="2 3" className="animate-[dashScroll_3s_linear_infinite]" data-id="element-297" />

        {/* Exit ramp from A9 */}
        <path d="M 88 35 Q 78 35 72 38 Q 66 41 62 42" fill="none" stroke="#d1d5db" strokeWidth="3" data-id="element-298" />
        <path d="M 88 35 Q 78 35 72 38 Q 66 41 62 42" fill="none" stroke="#e5e7eb" strokeWidth="2" data-id="element-299" />

        {/* Internal roads — dashed connecting paths */}
        <path d="M 40 27 L 52 27" fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="1.5" strokeDasharray="2 2" data-id="element-300" />
        <path d="M 61 36 L 65 42" fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="1.5" strokeDasharray="2 2" data-id="element-301" />
        <path d="M 29 34 L 27 55" fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="1.5" strokeDasharray="2 2" data-id="element-302" />
        <path d="M 54 46 L 58 48" fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="1.5" strokeDasharray="2 2" data-id="element-303" />
        <path d="M 42 65 L 46 68" fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="1.5" strokeDasharray="2 2" data-id="element-304" />
        <path d="M 38 52 L 30 55" fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="1.5" strokeDasharray="2 2" data-id="element-305" />
      </svg>

      {/* A9 Label */}
      <div className="absolute right-[7%] top-4 z-30" data-id="element-306">
        <div className="bg-yellow-500/90 text-white text-[10px] font-bold px-2 py-0.5 rounded-sm tracking-wider" data-id="element-307">
          A9
        </div>
      </div>

      {/* Ausfahrt 39 Label */}
      <div className="absolute right-[16%] top-[30%] z-30" data-id="element-308">
        <motion.div initial={{
        opacity: 0,
        x: 10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="flex items-center gap-1.5" data-id="element-309">
          <div className="w-6 h-px bg-gray-300" data-id="element-310" />
          <span className="text-[9px] text-gray-400 font-medium whitespace-nowrap tracking-wide" data-id="element-311">
            Ausfahrt 39
          </span>
        </motion.div>
      </div>

      {/* Building blocks */}
      {buildings.map(b => <motion.div key={b.id} className="absolute rounded-lg cursor-pointer flex flex-col items-center justify-center border transition-colors duration-300 z-20" style={{
      left: `${b.x}%`,
      top: `${b.y}%`,
      width: `${b.w}%`,
      height: `${b.h}%`,
      backgroundColor: b.bg,
      borderColor: hoveredId === b.id ? b.color : `${b.color}33`
    }} whileHover={{
      scale: 1.08,
      boxShadow: b.glow,
      zIndex: 30
    }} onHoverStart={() => setHoveredId(b.id)} onHoverEnd={() => setHoveredId(null)} data-id="element-312">
          <AnimatePresence data-id="element-313">
            {hoveredId === b.id && <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.8
        }} className="absolute inset-0 rounded-lg border" style={{
          borderColor: `${b.color}66`
        }} data-id="element-314" />}
          </AnimatePresence>

          <span className="text-xs md:text-sm font-bold" style={{
        color: b.color
      }} data-id="element-315">
            {b.icon}
          </span>
          <span className="text-[7px] md:text-[9px] font-semibold mt-0.5 text-center leading-tight px-1" style={{
        color: `${b.color}cc`
      }} data-id="element-316">
            {b.label}
          </span>

          <AnimatePresence data-id="element-317">
            {hoveredId === b.id && <motion.div initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 6
        }} className="absolute -bottom-8 left-1/2 -translate-x-1/2 whitespace-nowrap z-40" data-id="element-318">
                <div className="px-2.5 py-1 rounded-md text-[10px] font-semibold text-white" style={{
            backgroundColor: b.color
          }} data-id="element-319">
                  {b.label}
                </div>
              </motion.div>}
          </AnimatePresence>
        </motion.div>)}

      {/* Shell pump icons inside Shell area */}
      <div className="absolute z-10" style={{
      left: '19%',
      top: '28%'
    }} data-id="element-320">
        <div className="flex gap-[3px]" data-id="element-321">
          {[...Array(4)].map((_, i) => <div key={i} className="w-1 h-2.5 rounded-[1px] bg-red-500/30" data-id="element-322" />)}
        </div>
      </div>

      {/* IONITY charger dots */}
      <div className="absolute z-10" style={{
      left: '48%',
      top: '70%'
    }} data-id="element-323">
        <div className="flex gap-1.5" data-id="element-324">
          {[...Array(3)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-neon-green/40" data-id="element-325" />)}
        </div>
      </div>

      {/* LKW parking lines */}
      <div className="absolute z-10" style={{
      left: '14%',
      top: '62%'
    }} data-id="element-326">
        <div className="flex gap-[3px]" data-id="element-327">
          {[...Array(6)].map((_, i) => <div key={i} className="w-2.5 h-1 rounded-[1px] bg-teal-accent/25" data-id="element-328" />)}
        </div>
      </div>

      {/* Legend */}
      <div className="absolute bottom-3 left-3 z-30 flex flex-wrap gap-2" data-id="element-329">
        {buildings.map(b => <div key={b.id} className="flex items-center gap-1 text-[8px] text-gray-400" data-id="element-330">
            <div className="w-1.5 h-1.5 rounded-full" style={{
          backgroundColor: b.color
        }} data-id="element-331" />
            <span data-id="element-332">{b.label}</span>
          </div>)}
      </div>
    </div>;
}